import {DataSourceConfig} from "../components/table/interfaces/data-source-config.interface";
import {InputDataSource} from "./input-data-source.class";
import {MixedDataSource} from "./mixed-data-source.class";
import {OnlineDataSource} from "./online-data-source";
import {OfflineDataSource} from "./offline-data-source.class";
import {CustomDataSource} from "./custom-data-source";
import {DataService} from "../services/data/data.service";
import {HttpClient} from "@angular/common/http";
import {OfflineTableFilterService} from "../services/filters/offline-table-filter.service";
import {Injectable} from "@angular/core";

@Injectable()
export class CreatorDataSource {
  constructor(
    private dataService: DataService,
    private http: HttpClient,
    private offlineTableFilterService: OfflineTableFilterService,
  ) {
  }

  public create(config: DataSourceConfig): CustomDataSource {
    let dataSource: CustomDataSource;
    const operationType: string = config.operationType;
    switch (operationType) {
      case 'INPUT':
        dataSource = new InputDataSource(this.http, this.dataService, this.offlineTableFilterService);
        break;
      case 'MIXED':
        dataSource = new MixedDataSource(this.http, this.dataService, this.offlineTableFilterService);
        break;
      case 'ONLINE':
        dataSource = new OnlineDataSource(this.http, this.dataService);
        break;
      case 'OFFLINE':
        dataSource = new OfflineDataSource(this.http, this.dataService, this.offlineTableFilterService);
        break;
      default:
        throw new Error(`Error! Unknown data source type=${operationType}.`);
    }
    return dataSource;
  }
}


// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/data-sources/creator-data-source.ts